import React, { useContext, useState } from 'react'

export const COLOR = {
	GREEN: 'Green',
	RED: 'Red',
	BLUE: 'Blue',
	YELLOW: 'Yellow',
	PURPLE: 'Purple',
}

const ColorContext = React.createContext()

export const useColor = () => {
	return useContext(ColorContext)
}

export const ColorProvider = ({ children }) => {
	const [color, setColor] = useState(COLOR.GREEN)

	const handleColor = (color) => setColor(color)

	return (
		<ColorContext.Provider
			value={{
				color,
				handleColor,
			}}
		>
			{children}
		</ColorContext.Provider>
	)
}
